import { Menu } from '@base-ui/react/menu'
import type { PartProps } from '../../../lib/part-props'

/**
 * Props interface for MenuPortal component.
 * Extends base-ui's Menu.Portal.Props for portal rendering options.
 */
interface MenuPortalProps extends PartProps<Menu.Portal.Props> {}

/**
 * MenuPortal - Renders menu content in a portal outside the DOM hierarchy.
 *
 * This component ensures the menu popup is rendered at the root level of the DOM,
 * preventing z-index and overflow issues with parent containers.
 *
 * @example
 * ```tsx
 * <Menu.Portal>
 *   <Menu.Positioner>
 *     <Menu.Popup>
 *       {/* Menu content *\/}
 *     </Menu.Popup>
 *   </Menu.Positioner>
 * </Menu.Portal>
 * ```
 */
function MenuPortal({ children, ...props }: MenuPortalProps) {
  return <Menu.Portal {...props}>{children}</Menu.Portal>
}

export { MenuPortal }
